const app = {
  appMountEl: '#js-social-preview-app'
}

const data = {
  displayId: 'data-display-id'
}

export { app, data }
